import Vue from 'vue';
import Vuex from 'vuex';
import mutations from './mutations';
import getters from './getters';
import actions from './actions';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        user: null,
        visits: [],
        mails: [],
        hasSubscriptions: false,
        updatedEmail: '',
        version: '',
        updateRequired: false
    },
    mutations,
    actions,
    getters
});



// WEBPACK FOOTER //
// ./src/store/index.js